import {
  selectAppliedOffers,
  selectSelectedOffer,
  selectValidAppliedOffers,
} from './offers/offers.selectors';

export const loyaltySelectors = {
  // Offer actions
  selectAppliedOffers,
  selectSelectedOffer,
  selectValidAppliedOffers,
};
